import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  overflow: hidden;\n  width: auto;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  min-height: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-right: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  cursor: ", ";\n  display: flex;\n  padding: ", ";\n  transition: background-color ", ", color ", ";\n  width: 100%;\n\n  &:hover {\n    background-color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState } from 'react';
import styled from 'styled-components';
import { rgba } from 'polished';
import { color, property } from '@scp/ui-shared/theme/variables';
import { Subtext } from '@scp/ui-shared/components/typography';
import { withOutsideClick } from '@scp/ui-shared/core/hoc';
import { Icon } from '@scp/ui-shared/theme/icons';
import { rem, baselineToRem } from '@scp/ui-shared/theme/utils';
import { Popover } from '@scp/ui-shared/components/popover';
import { LinkOrButton } from '@scp/ui-shared/components/buttons';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
var Wrapper = styled(withOutsideClick('div'))(_templateObject());
var E2E_SUFFIX = '-menu-popover';
var Trigger = styled(LinkOrButton)(_templateObject2(), rem("".concat(property.borderRadius, "px")), function (props) {
  return props.disabled ? 'text' : 'pointer';
}, baselineToRem(2), property.transition, property.transition, function (props) {
  return props.disabled ? 'transparent' : rgba(color.palette.white, 0.1);
});
var TriggerWithRipple = withRippleEffect(Trigger, color.rippleOnDark, false);
var ItemIcon = styled(Icon).attrs({
  size: baselineToRem(5)
})(_templateObject3(), baselineToRem(2));
var Title = styled(Subtext).attrs({
  noMargin: true
})(_templateObject4(), baselineToRem(5));
var Content = styled(Popover)(_templateObject5());
export var MenuPopover = function MenuPopover(_ref) {
  var title = _ref.title,
      iconName = _ref.iconName,
      children = _ref.children,
      onClose = _ref.onClose,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      dataE2E = _ref.dataE2E;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var handlePopoverClose = function handlePopoverClose() {
    if (isOpen) {
      onClose && onClose();
      setIsOpen(false);
    }
  };

  var handleTriggerClick = function handleTriggerClick() {
    return isOpen ? handlePopoverClose() : setIsOpen(true);
  };

  return React.createElement(Wrapper, {
    onClickOutside: handlePopoverClose
  }, React.createElement(TriggerWithRipple, {
    onClick: handleTriggerClick,
    disabled: disabled,
    dataE2e: getE2eLabel(dataE2E || title, E2E_SUFFIX),
    "aria-label": title,
    "aria-haspopup": true,
    "aria-expanded": isOpen
  }, iconName && React.createElement(ItemIcon, {
    name: iconName,
    color: color.palette.white
  }), typeof title === 'string' ? React.createElement(Title, null, title) : title), React.createElement(Content, {
    open: isOpen,
    withShadow: true,
    noTriangle: true,
    padding: "0"
  }, children({
    onClose: function onClose() {
      return setIsOpen(false);
    }
  })));
};